import { ICost } from "@eventr/common";
import { createLocalCacheStore } from "./local-cache-store";

type ExpenseSyncAction = "add" | "edit" | "delete";
export interface LocalExpense {
  cost: ICost;
  itineraryId: number;
  syncAction: ExpenseSyncAction;
  /**
   * The organisation the expense was entered in. Absent on entries queued before this was
   * recorded, which the manager treats as belonging to whichever organisation is selected.
   */
  org?: string;
}

const getExpenseLocalStoreId = (costId: string) => `expense-${costId}`;

const store = createLocalCacheStore<LocalExpense>("expenses", (e) => getExpenseLocalStoreId(e.cost._id));

export const expenseLocalStore = {
  ...store,

  remove: async (costId: string) => {
    const storeId = getExpenseLocalStoreId(costId);
    return store.remove(storeId);
  },

  getByItineraryId: async (itineraryId: number) => {
    const all = await store.getAll();
    return all.filter((expense) => expense.data.itineraryId === itineraryId);
  },

  /**
   * Queued expenses belonging to the given organisation.
   *
   * The request base URL resolves from the selected organisation when the request is sent,
   * not when the expense was entered, so flushing the whole queue after switching
   * organisations would post to the wrong WordPress.
   */
  getByOrg: async (org: string) => {
    const all = await store.getAll();
    return all.filter((expense) => (expense.data.org ?? org) === org);
  },
};
